import { Box, makeStyles, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  outerBox: {
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2),
  },
  innerBox: {
    alignContent: 'center',
    alignItems: 'center',

    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2),
  },
  image: {
    backgroundColor: 'transparent',
  },

  button: {
    '& .MuiButton-label': {
      fontWeight: 'bold',
      letterSpacing: 2,
    },
  },
  cardRoot: {
    width: 300,
    margin: theme.spacing(2),
    height: 190,
    textAlign: 'center',
  },
  cardAction: {
    justifyContent: 'center',
    bottom: 0,
    textAlign: 'center',
  },
  pos: {
    marginBottom: 12,
  },

  img: {
    width: '128px',
    height: 'auto',
    filter:
      theme.palette.type === 'dark'
        ? `drop-shadow(0px 2px 0 #fafafa)
    drop-shadow(0px -2px 0 #fafafa)
    drop-shadow(2px 0px 0 #fafafa)
    drop-shadow(-2px 0px 0 #fafafa)
    drop-shadow(0.1rem 0.1rem 0.2rem rgba(0, 0, 0, 0.5))`
        : 'drop-shadow(0.1rem 0.1rem 0.2rem rgba(0, 0, 0, 0.5)',
  },
}));

export default function HomeGrid() {
  const classes = useStyles();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Box className={classes.outerBox}>
      <Box className={classes.innerBox}>
        <img src="/res/stei-itb.png" className={classes.img} />
      </Box>
      <Typography
        align="center"
        variant="h3"
        style={
          theme.palette.type === 'dark'
            ? {
              filter: 'drop-shadow(0.1rem 0.1rem 0.2rem rgba(0, 0, 0, 0.5)',
            }
            : {}
        }
      >
        LAYANAN AKADEMIK
      </Typography>
      <Typography
        align="center"
        variant="h3"
        style={
          theme.palette.type === 'dark'
            ? {
              filter: 'drop-shadow(0.1rem 0.1rem 0.2rem rgba(0, 0, 0, 0.5)',
            }
            : {}
        }
      >
        STEI ITB
      </Typography>
      <Box
        className={classes.innerBox}
        flexDirection={matches ? 'row' : 'column'}
      >
        <Card className={classes.cardRoot}>
          <CardContent>
            <Typography color="textPrimary" gutterBottom variant="h4">
              Tiket Baru
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              Mulai tiket permintaan untuk pelayanan baru
            </Typography>
          </CardContent>
          <CardActions className={classes.cardAction}>
            <Button
              size="small"
              className={classes.button}
              component={Link}
              color="primary"
              to="/layanan"
              variant="contained"
            >
              Tiket Baru
            </Button>
          </CardActions>
        </Card>
        <Card className={classes.cardRoot}>
          <CardContent>
            <Typography color="textPrimary" gutterBottom variant="h4">
              Cek Status
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              Cek status tiket pelayanan yang telah dibuat
            </Typography>
          </CardContent>
          <CardActions className={classes.cardAction}>
            <Button
              size="small"
              className={classes.button}
              component={Link}
              color="primary"
              to="/login"
              variant="contained"
            >
              Cek Status
            </Button>
          </CardActions>
        </Card>
      </Box>
    </Box>
  );
}
